<span *ngFor="let value of values; let i=index" [ngClass]="{'sep': true, 'divide' : i<values.length-1}">{{value}}</span>